import type { ProjectCategoryRef } from "@/lib/directus/utils/mapProjectCategories";
import type { ProjectItemType } from "./ProjectsBlock";

export function getProjectFilterCategories(
  projects: ProjectItemType[],
  serviceCategories: ProjectCategoryRef[]
): ProjectCategoryRef[] {
  const usedCategoryIds = new Set(
    projects.flatMap((project) => project.categories.map((category) => category.id))
  );

  return serviceCategories.filter((category) => usedCategoryIds.has(category.id));
}

export function projectMatchesSelectedCategories(
  project: ProjectItemType,
  selectedCategoryIds: string[]
): boolean {
  if (selectedCategoryIds.length === 0) {
    return true;
  }

  return project.categories.some((category) =>
    selectedCategoryIds.includes(category.id)
  );
}
